export function getUserHasTeamInterestMessage(
  userId: string,
  teamId: number,
  userName: string,
  teamName: string
) {
  return {
    unfurl_links: false,
    unfurl_media: false,
    blocks: [
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: new Date().toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }),
        },
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: '*User signed up for team claim notification*',
        },
      },
      {
        type: 'divider',
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `<http://admin.baseballnearyou.com/users/show/${userId}|View User in Admin App - *${userName}*>`,
        },
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `<http://admin.baseballnearyou.com/teams/show/${teamId}|View Team in Admin App - *${teamName}*>`,
        },
      },
    ],
  };
}
